const constants = {
  LIST_SIGNATURE_REQUESTS_PENDING: 'LIST_SIGNATURE_REQUESTS_PENDING',
  LIST_SIGNATURE_REQUESTS_SUCCESS: 'LIST_SIGNATURE_REQUESTS_SUCCESS',
  LIST_SIGNATURE_REQUESTS_FAILURE: 'LIST_SIGNATURE_REQUESTS_FAILURE',
};

export default constants;
